import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { AuthUserInfo } from 'src/app/models/index';
import { CommonService, UtilitiesService } from 'src/app/services/index';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$, Constants } from '../shared/index';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public userActivities = [];
  public userRole = '';
  public userMenus = [];
  private getUserInfoUrl = `${API_ENDPOINT$}/common/getCurrentUserDetail`;
  // private getUserInfoUrl = `${API_ENDPOINT$}/user/user-detail`;
  private loginOauthenUrl = `${API_ENDPOINT$}/authentication/token`;
  private logoutUrl = `${API_ENDPOINT$}/authentication/revoke-token`;
  private check_tokenUrl = `${API_ENDPOINT$}/authentication/check_token`;
  private takeOutFirstTimeOfUserUrl = `${API_ENDPOINT$}/common/takeOutFirstTimeOfUser`;
  //private heartBeatUrl = `${API_ENDPOINT$}/authentication/heart-beat`;
  constructor(
    private dataService: DataService,
    private commonService: CommonService,
    private utilitiesService: UtilitiesService
  ) {}
  public defaultMenus = [
    {
      id: 'home',
      title: 'Home',
      url: '/site-master',
      icon: 'bosch-ic-home',
      code: 'HOME'
    },
    // {
    //   'id':'contactUs',
    //   'title': 'Contact Us',
    //   'url': '/dummy-link',
    //   'icon': 'Bosch-Ic-server',
    //   'code': 'CONTACT'
    // },
    // {
    //   'id':'advancedDashboard',
    //   'title': 'Advanced Dashboard',
    //   'url': '/dummy-link',
    //   'icon': 'Bosch-Ic-server',
    //   'code': 'ADVD'
    // },
    {
      id: 'manage',
      title: 'Manage',
      url: '/dummy-link',
      icon: 'bosch-ic-clipboard',
      code: 'MNG',
      items: [
        {
          id: 'userManagement',
          title: 'User Management',
          url: 'user-management',
          code: 'USRMNG'
        },
        {
          id: 'ebyQBenchMarking',
          title: 'E/Q Benchmarking',
          url: 'sub-item-1',
          code: 'EQB'
        },
        {
          id: 'projectSettings',
          title: 'Project Settings',
          url: 'sub-item-2',
          code: 'PRJS'
        },
        {
          id: 'multiStepForms',
          title: 'Form',
          url: '/multi-step-form',
          code: 'FORM'
        },
        {
          id: 'manageReport',
          title: 'Manage Report',
          url: 'manage-report',
          code: 'MNGR'
        },
        {
          id: 'roleAndActivityManagement',
          title: 'User Role and Activity management',
          url: '/role-management',
          code: 'URAMNG'
        },
        {
          id: 'solarScheduler',
          title: 'Manage Solar Schedular',
          url: 'manage-solar-scheduler',
          code: 'MNGSS'
        }
      ]
    },
    {
      id: 'add',
      title: 'Add',
      url: '/dummy-link',
      icon: 'bosch-ic-document-add',
      code: 'ADD',
      items: [
        {
          id: 'addLoad',
          title: 'Add Load',
          url: 'add-load',
          code: 'ADDL'
        },
        // {
        //   'title': 'Add User',
        //   'url': 'add-user',
        //   'code': 'ADDU'
        // },
        {
          id: 'addMeter',
          title: 'Add Meter',
          url: 'add-meter',
          code: 'ADDM'
        },
        {
          id: 'addDCU',
          title: 'Add DCU',
          url: '/add-dcu',
          code: 'ADDD'
        },
        {
          id: 'addNode',
          title: 'Add Node',
          url: '/add-node',
          code: 'ADDN'
        },
        {
          id: 'addBuilding',
          title: 'Add Building',
          url: '/add-building',
          code: 'ADDB'
        }
      ]
    },
    {
      id: 'view',
      title: 'View',
      url: '/dummy-link',
      icon: 'bosch-ic-grid-view',
      code: 'VIEW',
      items: [
        {
          id: 'viewUsers',
          title: 'View Users',
          url: 'sub-item-0',
          code: 'VIEWU'
        },
        {
          id: 'myProfile',
          title: 'My Profile',
          url: 'sub-item-1',
          code: 'CHNP'
        },
        {
          id: 'viewRoles',
          title: 'View Roles',
          url: 'sub-item-2',
          code: 'VIEWR'
        },
        {
          id: 'viewSiteMaster',
          title: 'View Site Master',
          url: 'sub-item-2',
          code: 'VIEWSM'
        },
        {
          id: 'loadInventory',
          title: 'Load Inventory',
          url: 'load-inventory',
          code: 'LOADI'
        },
        {
          id: 'meterInventory',
          title: 'Meter Inventory',
          url: 'meter-inventory',
          code: 'MTRI'
        },
        {
          id: 'dcuInventory',
          title: 'DCU Inventory',
          url: 'dcu-inventory',
          code: 'DCUI'
        },
        {
          id: 'performanceMonitoring',
          title: 'Performance Monitoring',
          url: 'sub-item-2',
          code: 'PERM'
        },
        {
          id: 'serverHealth',
          title: 'Server Health',
          url: 'sub-item-2',
          code: 'SERVH'
        }
      ]
    },
    {
      id: 'report',
      title: 'Report',
      url: '/create-site-mat-table',
      icon: 'bosch-ic-analysis',
      code: 'REPORT',
      items: [
        // {
        //   'id':'solarDailyReport',
        //   'title': 'Solar Daily',
        //   'url': '/solar-daily/solar',
        //   'code': 'SOLARD'
        // },
        // {
        //   'id':'solarMonthlyReport',
        //   'title': 'Solar Monthly',
        //   'url': 'solar-monthly/solar',
        //   'code': 'SOLARM'
        // },
        // {
        //   'id':'energyDailyReport',
        //   'title': 'Energy Daily',
        //   'url': '/solar-daily/energy',
        //   'code': 'ENERD'
        // },
        // {
        //   'id':'energyMonthlyReport',
        //   'title': 'Energy Monthly',
        //   'url': 'solar-monthly/energy',
        //   'code': 'ENERM'
        // },
        {
          id: 'energyTreeExcel',
          title: 'Energy Report',
          url: '/energy-tree-excel',
          code: 'ENERD'
        }
      ]
    },
    {
      id: 'export',
      title: 'Export',
      url: '/create-site-mat-table',
      icon: 'bosch-ic-export',
      code: 'EXPORT',
      items: [
        {
          id: 'realtimeData',
          title: 'Realtime Data',
          url: 'realtime-data',
          code: 'REALD'
        }
        // {
        //   id: 'shiftWiseData',
        //   title: 'Shiftwise Data',
        //   url: 'sub-item-1',
        //   code: 'SHFTWD'
        // },
        // {
        //   id: 'solarPlantDailyReport',
        //   title: 'Solar Plant Daily Report',
        //   url: 'sub-item-2',
        //   code: 'SPDR'
        // },
        // {
        //   id: 'solarPlantMontyReport',
        //   title: 'Solar Plant Monthly Report',
        //   url: 'sub-item-2',
        //   code: 'SPMR'
        // },
        // {
        //   id: 'solarPlantCustomReport',
        //   title: 'Solar Plant Custom Duration Report',
        //   url: 'sub-item-2',
        //   code: 'SPCDR'
        // }
      ]
    },
    {
      id: 'help',
      title: 'Help',
      url: '/help',
      icon: 'bosch-ic-customerservice',
      code: 'HELP'
    }
  ];

  public login = (username: string, password: string): Observable<any> => {
    return this.dataService.postLogin(this.loginOauthenUrl, username, password);
  };

  logout() {
    this.dataService.getData(this.logoutUrl, false);
    this.utilitiesService.removePlantLogo();
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }
  getUserDetail(): Observable<any> {
    return this.dataService.getData(this.getUserInfoUrl);
  }
  /** Get user info from token */
  public getLoggedUser = (): Observable<AuthUserInfo> => {
    return of(this.getAuthUserInfo());
  };
  private loginHandlerError = (error: Response): any => {
    return throwError(error);
  };
  private getAuthUserInfo = (): AuthUserInfo => {
    let user = new AuthUserInfo();
    // user = JSON.parse(localStorage.getItem('currentUser'));
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      user = currentUser;
    }
    return user;
  };
  /**
   * Validate token
   * If validated, store the token into local Storge to use for all next requests based on Json Web Token(JWT)
   * */
  private validateToken = (dataToken: any): void => {
    // if (!dataToken.access_token || this.jwtHelper.isTokenExpired(dataToken.access_token)) {
    //     return null;
    // }
    // try {
    //     this.addTokens(dataToken);
    // } catch (ex) {
    // }
  };

  public isTokenExpired = (): boolean => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.expires_at) {
      const now = Math.round(new Date().getTime() / 1000);
      return now >= currentUser.expires_at;
    }
    return false;
  };
  public refreshToken = (): Observable<any> => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) {
      return null;
    }
    return this.dataService.refreshToken(
      this.loginOauthenUrl,
      currentUser.refresh_token
    );
  };

  public isMenuAvailable = (activities): boolean => {
    let result = false;
    for (let i = 0; i < activities.length; i++) {
      if (this.userActivities.indexOf(activities[i]) !== -1) {
        result = true;
        break;
      }
    }
    return result;
  };
  public doAuthorization = (activities): boolean => {
    let authorized = false;
    for (let i = 0; i < activities.length; i++) {
      const find = this.userActivities.find((c) => c === activities[i]);
      if (!this.commonService.isNullOrUndefined(find)) {
        authorized = true;
        break;
      }
    }
    return authorized;
  };
  public isAdmin = (): boolean => {
    return (
      this.userRole === Constants.USER_ROLE.ADMIN ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L1 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L2 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L3 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L4 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L5 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L6 ||
      this.userRole === Constants.USER_ROLE.TECH_SUPPORT_L7
    );
  };
  public isSiteAdmin = (): boolean => {
    return this.userRole === Constants.USER_ROLE.SITE_OWNER;
  };

  buildMenus(defaultMenus: any, menus: any, firstTime?: boolean): any[] {
    if (firstTime) {
      defaultMenus = this.defaultMenus;
    }
    defaultMenus.forEach((me) => {
      const menu = this.userMenus.find((c) => c.code === me.code);
      if (!this.commonService.isNullOrUndefined(menu)) {
        const newItem = Object.assign({}, me);

        if (me.items !== undefined && me.items.length > 0) {
          newItem.items = [];
          for (let i = 0; i < me.items.length; i++) {
            const element: any = me.items[i];
            const child = this.userMenus.find((c) => c.code === element.code);
            if (!this.commonService.isNullOrUndefined(child)) {
              newItem.items.push(element);
            }
            if (element.items !== undefined && element.items.length > 0) {
              newItem.items = this.buildMenus(element.items, newItem.items);
            }
          }
          menus.push(newItem);
        } else {
          menus.push(newItem);
        }
      }
    });
    // if (menus.nodes !== undefined && menus.nodes.length > 0) {
    //   node.nodes = [];
    //   for (let i = 0; i < obj.nodes.length; i++) {
    //     const element = obj.nodes[i];
    //     element.index = i;
    //     node.nodes = this.buildFileTree(element, node.nodes, currentSelected);
    //   }
    // }
    return menus;
  }
  takeOutFirstTimeOfUser(): Observable<any> {
    return this.dataService.getData(this.takeOutFirstTimeOfUserUrl);
  }

  // sendHeartBeat(): Observable<any> {
  //   return this.dataService.getData(this.heartBeatUrl, false);
  // }
}
